import { CREATE_POSITION, GET_POSITION, UPDATE_POSITION } from "./types";
import { PositionCreateType, PositionType } from "@type/HRM/position";

export const createPositionRequest = (data: PositionCreateType) => {
  return {
    type: CREATE_POSITION.CREATE_POSITION_REQUEST,
    payload: { data },
  } as const;
};

export const createPositionSuccess = (data: PositionType) => {
  return {
    type: CREATE_POSITION.CREATE_POSITION_SUCCESS,
    payload: { data },
  } as const;
};

export const createPositionFailed = () => {
  return {
    type: CREATE_POSITION.CREATE_POSITION_FAILED,
  } as const;
};

export const getPositionRequest = (data: number | null) => {
  return {
    type: GET_POSITION.GET_POSITION_REQUEST,
    payload: { data },
  } as const;
};

export const getPositionSuccess = (data: PositionType) => {
  return {
    type: GET_POSITION.GET_POSITION_SUCCESS,
    payload: { data },
  } as const;
};

export const getPositionFailed = () => {
  return {
    type: GET_POSITION.GET_POSITION_FAILED,
  } as const;
};

export const updatePositionRequest = (data: PositionCreateType) => {
  return {
    type: UPDATE_POSITION.UPDATE_POSITION_REQUEST,
    payload: { data },
  } as const;
};

export const updatePositionSuccess = (data: PositionType) => {
  return {
    type: UPDATE_POSITION.UPDATE_POSITION_SUCCESS,
    payload: { data },
  } as const;
};

export const updatePositionFailed = () => {
  return {
    type: UPDATE_POSITION.UPDATE_POSITION_FAILED,
  } as const;
};

export type PositionActions =
  | ReturnType<typeof createPositionRequest>
  | ReturnType<typeof createPositionSuccess>
  | ReturnType<typeof createPositionFailed>
  | ReturnType<typeof getPositionRequest>
  | ReturnType<typeof getPositionSuccess>
  | ReturnType<typeof getPositionFailed>
  | ReturnType<typeof updatePositionRequest>
  | ReturnType<typeof updatePositionSuccess>
  | ReturnType<typeof updatePositionFailed>;
